import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import InsightAvailability from "./InsightAvailability";

const styles = {
    selectedTab: {
        borderRadius: 0,
        padddingLeft: '16px',
        paddigRight: '16px',
        borderTop: 'solid 1px black',
        borderLeft: 'solid 1px black',
        borderRight: 'solid 1px black',

    },
    tab: {
        backgroundColor: '#1D8ABF',
        color: '#fff',
        borderRadius: 0,
        borderBottom: 'solid 1px black',
        padddingLeft: '16px',
        paddigRight: '16px',
        '&:hover': {
            backgroundColor: '#1D8ABF'
        }
    }
}
interface IInsightReportMatrixDialogProps {
    client: string
    open: boolean
    setOpen: (value: boolean) => void
}
interface Tab {
    id: number;
    name: string;
}
const tabs: Tab[] = [
    { id: 0, name: "Insight Availability", },
    { id: 1, name: "", },
    { id: 2, name: "", },
];

export default function InsightHelpDialog({ client, open, setOpen }: IInsightReportMatrixDialogProps) {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth
                maxWidth='md'
                PaperProps={{
                    sx: {
                        height: '80%',
                        padding: '0px',
                    }
                }}
            >
                <DialogTitle>Insight Help</DialogTitle>
                <DialogContent sx={{ overflow: 'hidden', }}>
                    {/*Tab Selection*/}
                    <Stack direction="row">
                        {tabs.map((tab, i) => (
                            < Button
                                key={tab.id}
                                fullWidth
                                onClick={() => setTabIndex(0)}
                                sx={tabIndex === tab.id ? styles.selectedTab : styles.tab}
                                style={tabIndex !== tab.id && i !== tabs.length - 1 && i !== tabIndex - 1 ? { borderRight: '1px white solid' } : {}}
                            >
                                {tab.name}
                            </Button >
                        ))}
                    </Stack>

                    <Box sx={{
                        borderBottom: 'solid 1px black',
                        borderLeft: 'solid 1px black',
                        borderRight: 'solid 1px black',
                        height: '97%',
                    }}>
                        {/*Selected Tab Content*/}
                        <InsightAvailability client={client} />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ paddingRight: 3 }}>
                    <Button onClick={() => setOpen(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment >
    );
};
